module.exports = __webpack_public_path__ + "static/img/dress_shes_default.aee444d2.png";